import { styled } from "themes"

export const Section = styled.section`
  height: 692px;
`
